import React from 'react';
import { CircleHelp } from 'lucide-react';
import { Button } from '../Button/Button';
import './account-actions.css';

export interface AccountActionsProps {
  onSignOut: () => void;
  onDeleteAccount?: () => void;
  deleteTooltip?: string;
  className?: string;
  figmaNode?: string;
}

export function AccountActions({
  onSignOut,
  onDeleteAccount,
  deleteTooltip = 'Удаление аккаунта приведёт к безвозвратной потере всех данных, рейтинга и истории поездок',
  className = '',
  figmaNode = '2867:35623',
}: AccountActionsProps) {
  return (
    <div className={`lovo-account-actions ${className}`.trim()} data-figma-node={figmaNode}>
      <Button kind="primary" size="medium" onClick={onSignOut}>
        Выйти из аккаунта
      </Button>
      <div className="lovo-account-actions__delete">
        <Button
          kind="tertiary"
          size="medium"
          icon="none"
          onClick={onDeleteAccount}
        >
          Удалить аккаунт
        </Button>
        <div className="lovo-account-actions__tooltip-wrapper" tabIndex={0}>
          <CircleHelp aria-hidden="true" />
          <div className="lovo-account-actions__tooltip" role="tooltip">
            {deleteTooltip}
          </div>
        </div>
      </div>
    </div>
  );
}
